import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import ReactIframeResizer from "../common/iFrameResizerComponent";
import { getURLPath } from '../../helpers/Tools';
import { logUI } from '../../api/andyliticsApi';

const SURVEY_CANCELLED = "surveycancelled";
const SURVEY_COMPLETED = "surveycompleted";

/**
 * Video Visit Survey.
 * 
 */

class VideoVisitSurvey extends React.Component {
    constructor(props) {
        super(props);
        this.serverData = this.props.serverData;
        this.state = { isSurveyCompleted: false };
        this.processWindowMessage = this.processWindowMessage.bind(this);

    }

    componentDidMount() {
        this._isMounted = true;
        window.formChanged = false;
        window.addEventListener("message", this.processWindowMessage);
        const { surveyUrl } = this.props;
        let andyliticsJson = { surveyUrl };
        logUI("MBHWeb.UI.VideoVisitSurvey.ComponentDidMount", new Date(), getURLPath(), andyliticsJson);
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.formChanged = false;
        window.removeEventListener("message", this.processWindowMessage);
    }

    processWindowMessage(messageEvent) {
        const { submitSurvey, isSdcVisit, surveyIdForSDCV2, surveyIdForAmbulatoryV2, twilioUserName } = this.props;
        let surveyLogValue = {
            SurveryId: isSdcVisit ? surveyIdForSDCV2 : surveyIdForAmbulatoryV2,
            VisitType: isSdcVisit ? "SDC" : "Ambulatory",
            twilioUserName: twilioUserName
        };
        if (messageEvent.data && messageEvent.data === SURVEY_CANCELLED) {
            logUI("MBHWeb.UI.VideoVisitSurvey.Cancelled", new Date(), getURLPath(), surveyLogValue);
            this.props.history.push("/dashboard");
        } else if (messageEvent.data && messageEvent.data === SURVEY_COMPLETED) {
            logUI("MBHWeb.UI.VideoVisitSurvey.Completed", new Date(), getURLPath(), surveyLogValue);
            this.setState({ isSurveyCompleted: true });
            if (submitSurvey)
                submitSurvey();
        }
    }

    render() {
        const { reloadKey, csnId, userDetails, surveyUrl, isSdcVisit, surveyIdForSDCV2, surveyIdForAmbulatoryV2, userName, twilioUserName } = this.props;
        const { isSurveyCompleted } = this.state;
        const surveyId = isSdcVisit ? surveyIdForSDCV2 : surveyIdForAmbulatoryV2;
        const userNameForSurvey = twilioUserName ? twilioUserName : userName ? userName : null;

        //Adding target key param in survey to handle our css.
        const url = surveyUrl + "ui/TakeVideoVisitSurvey/" + surveyId + "?UserId=" + userNameForSurvey + "&externalEventId=" + csnId + "&platform=web";
        const iframeResizerOptions = { checkOrigin: false, scrolling: true, heightCalculationMethod: 'bodyScroll', warningTimeout: 10000 };
        const iframeResizerStyle = this.props.style || { width: '100%' };
        const formID = this.props.id ? this.props.id : "VideoVisitSurvey";

        return url && !isSurveyCompleted &&
            <div className="mychartDataTile wellnessAssessmentTile">
                <React.Fragment >
                    <ReactIframeResizer ref="thisFrame" key={reloadKey} id={formID} title="Video Visit Survey" iframeResizerOptions={iframeResizerOptions} src={url} style={iframeResizerStyle} />
                </React.Fragment>
            </div>
    }
}

const mapStateToProps = (state) => {
    return {
        userName: state.domain.un,
        userDetails: state.sso.userDetails,
        loginStatus: state.domain.ls,
        serverData: state.session.serverData,
        token: state.domain.t,
        reloadKey: state.session.reloadKey,
        empId: state.domain.ei,
        isEmployee: state.domain.ie,
        surveyUrl: state.session.serverData && state.session.serverData.surveyUrl,
        
        surveyIdForSDCV2: state.session.serverData && state.session.serverData.surveyIdForSDCV2,
        surveyIdForAmbulatoryV2: state.session.serverData &&  state.session.serverData.surveyIdForAmbulatoryV2
    };
};

export default withRouter(connect(mapStateToProps, null)(VideoVisitSurvey));
